/**
 * Humanize technical status source and reason strings for display.
 *
 * Raw backend values like 'WORKER_PROBE' or 'PING_EXIT_1' are mapped
 * to operator-friendly labels. Unknown values get sentence-case fallback.
 */

const STATUS_SOURCE_LABELS: Record<string, string> = {
  WORKER_PROBE: 'Automatic reachability check',
  MANUAL_PROBE: 'Manual ping',
  FILE_INGESTION: 'Latest RTU file received',
  STARTUP_DEFAULT: 'Waiting for first status update',
  LIVENESS_PROBE: 'Scheduled liveness check',
  COMMAND_PROBE: 'Action connectivity check',
};

const STATUS_REASON_LABELS: Record<string, string> = {
  PING_ALL_FAILED: 'All ping attempts failed',
  PING_EXIT_1: 'Device unreachable',
  PING_PARTIAL_SUCCESS: 'Some ping attempts succeeded',
  PING_SUCCESS: 'Device responded',
  PING_TIMEOUT: 'Connection timed out',
  PING_TARGET_INVALID: 'Ping target is invalid',
  PING_TARGET_MISSING: 'Ping target is missing',
  PING_TARGET_UNAVAILABLE: 'Ping target is unavailable',
  PING_UNRESOLVED: 'Ping attempt did not complete',
  FILE_RECEIVED: 'Data file received',
  FILE_WINDOW_EXPIRED: 'No recent data',
  RTU_MISSING: 'RTU was not found',
  RTU_SNAPSHOT_MISSING: 'RTU connectivity snapshot is missing',
  STARTUP: 'System startup',
  PING_EXIT_0: 'Device responded',
};

const formatTitleCase = (raw: string): string =>
  raw
    .replaceAll('_', ' ')
    .toLowerCase()
    .replace(/\b\w/g, (ch) => ch.toUpperCase());

export const humanizeStatusSource = (raw: string | null | undefined): string =>
  raw ? STATUS_SOURCE_LABELS[raw] ?? formatTitleCase(raw) : 'Source not reported';

export const humanizeStatusReason = (raw: string | null | undefined): string =>
  raw ? STATUS_REASON_LABELS[raw] ?? formatTitleCase(raw) : '—';
